import React from "react";
import { FluentButton } from "../../../../../../components/FluentUI/Fluent-Button";
import FluentUiIcon from "../../../../../../assets/fluent-ui-icon";
import { FluentTooltip } from "../../../../../../components/FluentUI/Fluent-Tooltip";
import MoveField from "../../../../../../assets/Illustrations/MoveField.svg";
import {
  DeleteLayoutFormFieldUtil,
  FormNames,
  ModifyLayoutFromFieldUtil,
} from "./task-layout-util";
import { TaskLayoutSectionItem } from "./task-layout-section-item";
import { RemoveEmptyIds } from "../form-design/form-design-util";
import PropTypes from "prop-types";

export const TaskLayoutSection = ({
  section,
  label,
  taskLayout,
  setTaskLayout,
}) => {
  const SaveField = (currentField) => {
    const newTaskLayout = ModifyLayoutFromFieldUtil(
      taskLayout.data,
      label,
      currentField
    );

    setTaskLayout((prev) => ({
      ...prev,
      data: newTaskLayout,
    }));
  };

  const DeleteField = (currentField) => {
    const { newTaskLayout, newFieldId } = DeleteLayoutFormFieldUtil(
      taskLayout.data,
      label,
      currentField
    );

    setTaskLayout((prev) => ({
      ...prev,
      DynamicFormFieldIdsToBeDeleted: RemoveEmptyIds(
        prev.DynamicFormFieldIdsToBeDeleted,
        newFieldId
      ),
      data: newTaskLayout,
    }));
  };

  return (
    <div className="task-layout-content-section">
      <div className="task-layout-content-section-title">
        {label}
        <sup>
          <FluentTooltip
            target={
              <span>
                <FluentUiIcon
                  name={"InfoRegular"}
                  color={"#424242"}
                  size={16}
                />
              </span>
            }
            text={
              label === FormNames.TaskDetailsForm
                ? `Detail Fields capture information and provide additional context to the Tasks.`
                : `Comment Fields are the Fields people can fill out when they submit a comment.`
            }
          ></FluentTooltip>
        </sup>
      </div>
      <div className="task-layout-content-section-all-fields">
        {section?.Fields?.map((field, index) => (
          <TaskLayoutSectionItem
            key={`${field.LocalLabel}-${index}`}
            field={field}
            index={index}
            SaveField={SaveField}
            DeleteField={DeleteField}
          ></TaskLayoutSectionItem>
        ))}
        {(section?.Fields?.length === 0 || !section) && (
          <div className="task-layout-content-section-no-form">
            <img
              className="task-layout-content-section-no-form-image"
              src={MoveField}
              alt={"MoveField"}
            ></img>
            <div className="task-layout-content-section-no-form-text">
              To get started, click the “Create new Field” button, or add fields
              from right panel.
            </div>
          </div>
        )}
      </div>
      <div className="task-layout-content-section-action">
        <FluentButton
          icon={
            <FluentUiIcon name={"AddRegular"} color={"#bdbdbd"} size={20} />
          }
          disabled={true}
          onClick={() => {}}
          text={"Create new Field"}
        />
      </div>
      {label === FormNames.TaskDetailsForm && (
        <div className="task-layout-content-section-divider"></div>
      )}
    </div>
  );
};

TaskLayoutSection.propTypes = {
  section: PropTypes.object,
  label: PropTypes.string,
  taskLayout: PropTypes.object,
  setTaskLayout: PropTypes.func,
};
